exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#banner_thankyou[data-v-5e773809] {\n  /* background-color: #a2c7e6; */\n  background: linear-gradient(90deg, #93bcde 50%, #a2c7e6 50%);\n}\n.link[data-v-5e773809] {\n  color: #2b2b2b;\n  font-weight: 700;\n  text-decoration: none;\n}\n.link > img[data-v-5e773809] {\n  margin-right: 5px;\n  transition: all 0.2s ease-in-out;\n}\n.link:active > img[data-v-5e773809] {\n  margin-right: 8px;\n}", ""]);

// exports
